import React, { useLayoutEffect, useState } from 'react';

import { AiInfoItemWithMembers, getRobotListWithMembers } from '@mygpt/app/collaborate/services';

export const useRobotListWithMembers = () => {
  const [loading, setLoading] = React.useState(false);

  const [data, setData] = useState<AiInfoItemWithMembers[]>([]);
  const [error, setError] = useState<Error | null>(null);
  const [page, setPage] = React.useState<{ page: number; total: number; size: number; pages: number }>({
    page: 1,
    total: data.length,
    pages: 1,
    size: 10,
  });

  const loadList = React.useCallback(async (params: Parameters<typeof getRobotListWithMembers>[0]) => {
    setLoading(true);
    return getRobotListWithMembers({ size: 10, ...params })
      .then((res) => {
        setData(res.data.items);
        setPage({
          page: res.data.page,
          total: res.data.total,
          pages: res.data.pages,
          size: res.data.size,
        });
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handlePageChange = React.useCallback(
    (options: Partial<{ page: number; size: number }>) => setPage((prev) => ({ ...prev, ...options })),
    []
  );

  useLayoutEffect(() => {
    loadList({ page: page.page, size: page.size });
  }, [loadList, page.page, page.size]);

  return {
    error,
    loading,
    data,
    page,
    setPage: handlePageChange,
    loadList,
  };
};
